import React from 'react';
import {orgId} from '../../../context/context';
import OpenInNewLink from '../../../libs/react-components-admin/link/open-in-new-link';

export default class Step1 extends React.Component {

  render() {
    return <ul style={{ lineHeight: '1.8em' }}>
      <li>
        Open your <OpenInNewLink href={`https://${orgId}/admin/themes/current/editor?previewPath=%2Fcart`}>theme editor</OpenInNewLink>
      </li>
      <li>
        If your cart is empty, click on any product and add it to the cart.
      </li>
      <li>
        In the left panel, click on &apos;Add block&apos; or &apos;Add section&apos;, scroll down and choose &apos;Custom Form&apos;:<br />
        <img src="/images/osv2-apps-custom-form.png" alt="" />
      </li>
      <li>
        Click on &apos;Custom Form&apos; to reveal the configuration panel (it might appear on the opposite side of the page).<br />
        Choose Behavior: &apos;Cart page - add values to order&apos;:
      </li>
      <li>
        Click on &apos;Save&apos; (top right).
      </li>
    </ul>
  }

}
